export const FEATURES = {
	homeHeroCarousel: false,
};
